/** @badge Native — TG UI Spinner
 *  @when   неопределённое ожидание без процента — короткий инлайн-лоадер в кнопке/строке
 *  @not    известный процент (это Progress/CircularProgress) · загрузка списка (это Skeleton)
 *  @breaks `color` и `thickness` есть в Props, но в TGSpinner не передаются — молча игнорятся
 */
"use client";

import { Spinner as TGSpinner } from "@telegram-apps/telegram-ui";

interface Props {
  size?: number;
  color?: string;
  thickness?: number;
}

function mapSize(px: number): "s" | "m" | "l" {
  if (px <= 16) return "s";
  if (px <= 24) return "m";
  return "l";
}

export default function Spinner({ size = 20 }: Props) {
  return <TGSpinner size={mapSize(size)} />;
}
